import { render, staticRenderFns } from "./LoadVideo.vue?vue&type=template&id=4f9c23e5&scoped=true"
import script from "./LoadVideo.vue?vue&type=script&lang=js"
export * from "./LoadVideo.vue?vue&type=script&lang=js"
import style0 from "./LoadVideo.vue?vue&type=style&index=0&id=4f9c23e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c23e5",
  null
  
)

export default component.exports